<template>
  <nav class="flex items-center flex-wrap lg:flex-no-wrap bg-wine p-6">
    <div class="flex flex-grow lg:flex-grow-0 items-center w-1/2">
      <div class="flex items-center text-white mr-6">
        <nuxt-link to="/#">
          <img :src="logo" alt="Abbes Weinladen" />
        </nuxt-link>
      </div>
      <div class="block lg:hidden mr-4 md:mr-4">
        <button class="flex items-center px-3 py-2 rounded text-white" @click="openMenu">
          <svg class="fill-current h-6 w-6 md:h-10 md:w-10" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <title>Menu</title>
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </svg>
        </button>
      </div>
    </div>
    <div :class="{ hidden: !isOpen }" class="w-full block flex-grow lg:flex lg:items-center lg:w-auto">
      <div class="lg:flex lg:flex-row lg:flex-row-reverse lg:flex-grow text-sm">
        <nuxt-link
          v-for="(item, key) in nav"
          :key="key"
          :to="`${item.target}`"
          class="block mx-4 my-6 text-base md:text-2xl lg:text-lg lg:inline-block text-right text-white hover:bg-white hover:text-wine"
        >
          &nbsp;{{ item.name }}&nbsp;
        </nuxt-link>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import logo from '@/assets/img/logo.png'

export default {
  data() {
    return {
      logo,
      isOpen: false,
    }
  },
  computed: {
    ...mapGetters({
      nav: 'menu/nav',
    }),
  },
  methods: {
    openMenu() {
      this.isOpen = !this.isOpen
    },
  },
}
</script>

<style lang="scss" scoped>
// nav a::after {
//   left: 1rem;
//   right: 1rem;
// }

// nav .active a,
// nav a:focus,
// nav a:hover {
//   color: rgb(210, 0, 15);
//   text-decoration: none;
// }

// nav a::after {
//   content: '';
//   position: absolute;
//   top: 5rem;
//   left: 0.666rem;
//   right: 0.666rem;
//   bottom: -0.625rem;
//   height: 200px;
//   background-color: rgb(210, 0, 15);
//   opacity: 0;
//   transition: opacity 0.6s ease 0s, bottom 0.6s ease 0s;
// }
//
</style>
